import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import DomeHeader from "../components/DomeHeader";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { DomeText, Header2, Header3, Header6 } from "../components/typography";
import richText from "../utils/richText";
import { TertiaryButton } from "../components/Button";
import { Link } from "gatsby";

const Wrapper = styled.div`
  padding: 64px 32px;
  background: ${Colors.cream2};

  ${Header2} {
    margin: 24px auto 50px;
    max-width: 800px;

    color: ${Colors.grey};
    text-align: center;

    @media ${Breakpoints.desktop} {
      margin: 24px auto 80px;
    }
  }

  > div:last-child div:first-child {
    ${DomeText} {
      text-align: center;
      display: block;
      color: ${Colors.greyLight};
    }

    ${Header6} {
      color: ${Colors.hunter};
      text-align: center;

      margin: 8px 0 40px;
    }
  }

  @media ${Breakpoints.tablet} {
    > div:last-child div:first-child {
      ${DomeText}, ${Header6} {
        text-align: left;
      }
    }
  }
`;

const Items = styled.div`
  width: 100%;
  margin: 0 auto;

  @media ${Breakpoints.desktop} {
    width: 90%;
  }

  .item {
      display: flex;
      margin-bottom: 50px;
      flex-wrap: wrap;

      @media ${Breakpoints.desktop} {
        margin-bottom: 100px;
      }

      .image {
        width: 100%;
        padding-bottom: 25px;

        @media ${Breakpoints.desktop} {
          width: 50%;
          padding: 0;
        }

        .inner {
            width: 100%;
            padding-bottom: 100%;
            position: relative;

            .gatsby-image-wrapper {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
            }
        }
      }

      .text {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          @media ${Breakpoints.desktop} {
            width: 50%;
            padding: 0px 50px;
          }

          ${Header3} {
              color: ${Colors.hunter};
              margin-bottom: 10px;
          }

          ${DomeText} {
              color: ${Colors.medGrey};
              margin-bottom: 10px;
          }

          p {
              color: ${Colors.grey};
          }
      }

      &.right {
          .image {
              @media ${Breakpoints.desktop} {
                order: 2;
              }
          }

          .text {
            @media ${Breakpoints.desktop} {
              order: 1;
              padding-left: 0px;
            }
          }
      }
  }
`

export default function FoundersSection({ founders }) {
  return (
    <Wrapper>
      <DomeHeader text="Who We Are" centered />
      <Header2>About the Founders</Header2>
      
      <Items>
          {founders.map((item, index) => (
            <div 
              className={`item ${index % 2 == 0 ? `left` : `right`}`} 
              key={index}
            >
                <div className="image">
                    <div className="inner">
                        <Image style={{ position: 'absolute' }} fluid={item.image.fluid} />
                    </div>
                </div>

                <div className="text">
                    <Header3>{item.name}</Header3>
                    <DomeText>{ item.title }</DomeText>
                    <p>{ richText(item.bio.raw) }</p>
                </div>
            </div>
          ))}
      </Items>
    </Wrapper>
  );
}
